<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt" id="Hsalud">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dCincoM dtOcho dmOnce">
                    <h1>SALUD INTEGRAL</h1>
                    <p>
                        Ofrecer servicios de salud integral es muy importante para nosotros, ya que además de apoyar el bienestar físico, procuramos el emocional y el social, para impulsar la vida sana de cada persona.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
    </div>
<div class="contenedorIntSub">

    <div class="FcfrCst">
        <div class="FcfrCstInt dSieteM dtDiez dmDoce flx">
            <div class="dDiez dmOnce FcttAzul flx">
                <div class="dDoce">
                    <h3 class="FcifrasDatos text-white pt-1 mb-2">HAZ CLIC Y UBICA TU UNIDAD MÁS CERCANA </h3>
                </div>
                <div class="dCuatro dmCuatro FcfrBllt">
                <a (click)="goConsultorios()">
                    <img src="./assets/images/icon-consultorios.svg" alt="Consultorios médicos">
                    <p class="FcifrasDatos">
                        CONSULTORIOS<br/>MÉDICOS
                    </p>
                </a>
                </div>
                <div class="dCuatro dmCuatro FcfrBllt">
                <a (click)="goConsultoriosDentales()">
                    <img src="./assets/images/icon-dentales.svg" alt="Consultorios dentales">
                    <p class="FcifrasDatos">
                        CONSULTORIOS<br/>DENTALES
                    </p>
                </a>
                </div>
                <div class="dCuatro dmCuatro FcfrBllt">
                    <a (click)="goConsultoriosNutricionales()">
                        <img src="./assets/images/icon-nutricion.svg" alt="Consultorios nutricionales">
                        <p class="FcifrasDatos">
                            CONSULTORIOS<br/>NUTRICIONALES
                        </p>
                    </a>
                </div>
                <div class="dCuatro dmCuatro FcfrBllt">
                    <a (click)="goConsultoriosPsicologicos()">
                        <img src="./assets/images/icon-psicologico.svg" alt="Consultorios nutricionales">
                        <p class="FcifrasDatos">
                            CONSULTORIOS<br/>PSICOLÓGICOS
                        </p>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div class="espacioDefault"></div>

    <div class="FcntHf flx">
        <div id="FimgCntHf" class="FcntHimg dDoce text-center">
            <img src="./assets/images/salud-consulta.jpg" width="100%" alt="Consulta médica" />
        </div>
        <div class="FcntHtexto">
            <!---<p>
                Los consultorios son supervisados frecuentemente por el grupo de supervisores, contamos además con un comité de vigilancia de prescripciones médicas. <br/><br/>
                Durante el mes de <span class="txtBold">{{month}}</span> del <span class="txtBold">{{year}}</span> se impartieron un total de <span class="txtBold">{{consultas | number}}</span> consultas médicas.<br/><br/>
                Las cédulas profesionales de los médicos y odontólogos que ingresan a los consultorios de Fundación Best, son enviadas a la Dirección General de Profesiones, para validar su autenticidad.<br/><br/>
                Los consultorios cumplen con las normas y requisitos que exige la Secretaría de Salud de los mandatos Federales y Regionales de las Leyes Generales de Salud (Alta Sanitaria, Responsable Sanitario y Verificaciones, etc.) los cuales están ampliamente equipados para impartir consulta de excelente calidad y calidez humana.<br/><br/>
                Los médicos y odontólogos de las Unidades foráneas cuentan además según se requiere con sus cédulas estatales para el ejercicio de la profesión médica.<br/><br/>
                <span class="txtBold">
                Los médicos y odontólogos que ingresan a Fundación Best, A.C., son seleccionados:<br/><br/>
                    <ol>
                        <li>Vía curricular</li>
                        <li>A través de una entrevista (en donde se valúan experiencia y conocimientos)</li>
                        <li>Mediante la verificación y cotejo con documentación original</li>
                    </ol>
                </span>
            </p>--->
            <p><strong>Calidad y cumplimiento normativo</strong></p>
            <p>Los consultorios de Fundación Best, A.C., cumplen con altos estándares de calidad y con las disposiciones normativas aplicables, con el propósito de contribuir a que los médicos y odontólogos comodatarios brinden atención médica de calidad y calidez humana. Durante el mes de julio de 2026, a través de la red de médicos comodatarios, se impartieron un total de 14,764,646 consultas médicas.</p>
            <p><strong>Verificación de cédulas profesionales</strong></p>
            <p>Las cédulas profesionales de los médicos y odontólogos que se incorporan como comodatarios y prestadores de servicios independientes en los consultorios de Fundación Best, A.C., son sometidas a un proceso de verificación ante la Dirección General de Profesiones, con el propósito de corroborar su autenticidad y la habilitación profesional correspondiente.</p>
            <p><strong>Cumplimiento sanitario y equipamiento</strong></p>
            <p>
                Los consultorios cumplen con las normas y requisitos establecidos por las autoridades sanitarias federales y estatales, conforme a la legislación general de salud y demás disposiciones aplicables, incluyendo los trámites y requisitos relativos al alta sanitaria, responsable sanitario y verificaciones, según corresponda.<br>
                Asimismo, cuentan con el equipamiento necesario para que los médicos y odontólogos comodatarios puedan brindar consultas de excelente calidad y calidez humana.<br>
                Los médicos y odontólogos comodatarios de las unidades foráneas cuentan, además, con las cédulas estatales que, en su caso, sean requeridas para el ejercicio de su profesión.
            </p>
            <p><strong>Proceso de selección de médicos y odontólogos comodatarios</strong></p>
            <p>Los médicos y odontólogos que se incorporan como comodatarios a Fundación Best, A.C., son seleccionados mediante un proceso que comprende:</p>
            <ol class="txtBold">
                <li>Evaluación curricular.</li>
                <li>Entrevista, en la que se valoran su experiencia y conocimientos.</li>
                <li>Verificación y cotejo de la documentación original.</li>
            </ol>
        </div>
    </div>

    <!----

    <div class="dDiez dtDiezM dmOnce FTri text-justify">
        <p>
            Preocupados por su salud brindamos servicios de atención integral al alcance de todos los mexicanos.<br/><br/>
            En Fundación Best, a través de nuestros consultorios y médicos recibirá un diagnóstico y tratamiento adecuados. Así mismo, en  <a href="https://www.ssdrsimi.com.mx/" target="_blank" rel="noopener">Sistemas De Salud Del Dr. Simi </a> encontrará a su alcance análisis clínicos y estudios de gabinete para confirmar y/o descartar algún diagnóstico. Y por supuesto, en  <a href="https://www.farmaciasdesimilares.com/" target="_blank" rel="noopener">Farmacias Similares</a> tendrá la posibilidad de conseguir su medicamento a un bajo costo, calidad y eficacia comprobada. Además, contamos con apoyo psicológico gratuito vía telefónica y correo electrónico, las 24 horas del día, a través del <a href="https://simisae.com.mx/" target="_blank" rel="noopener">SIMISAE</a>.
        </p>

        <div class="FtriSld text-center">
            <div class="FtriSldInt dCinco dmSiete">
                <a href="https://fundacionbest.org.mx/" target="_blank" rel="noopener"><img src="./assets/images/triangulo-salud-FundacionBest.png" alt="Fundación BEST" id="TS01"></a>
                <a href="https://www.ssdrsimi.com.mx/" target="_blank" rel="noopener"><img src="./assets/images/triangulo-salud-analisisClinicos.png" alt="Análisis Clínicos del Dr. Simi" id="TS02"></a>
                <a href="https://www.farmaciasdesimilares.com/" target="_blank" rel="noopener"><img src="./assets/images/triangulo-salud-farmaciasSimilares.png" alt="Farmacias Similares" id="TS03"></a>
                <img src="./assets/images/triangulo-salud-logo.png" alt="Triángulo de la salud" id="TS00">
            </div>
        </div>

    </div>-->

</div>

</div>
